import env from 'enviro';
import { gate } from 'hub-http/gates';
import { useLocalStorage } from './useLocalStorage';
import { usePortalGates } from './useUserInfo';
const getIsQAProxy = () => window.location.hostname.indexOf('wthubspot') >= 0;

/**
 * @description A React hook for checking if a portal is ungated for a specific feature gate.
 * Supports QA environment overrides via localStorage for testing purposes.
 *
 * @param gateKey - The feature gate key to check - remember to use the `gate` function from hub-http/gates!
 * @returns Boolean indicating whether the portal is ungated for the specified feature
 *
 * @example
 * // Create a specific hook for a feature gate
 * export const useIsUngatedForCommerceHubInbound25 = () => {
 *   const gateKey = gate('SSM:CommerceHubInbound25');
 *   return useIsUngated(gateKey);
 * };
 *
 * // Use the specific hook in a component
 * const MyComponent = () => {
 *   const isUngated = useIsUngatedForCommerceHubInbound25();
 *
 *   if (isUngated) {
 *     return <NewFeatureComponent />;
 *   }
 *
 *   return <DefaultComponent />;
 * };
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useIsUngated = gateKey => {
  const gates = usePortalGates();
  const isQA = env.isQa() || getIsQAProxy();
  const [override] = useLocalStorage(`${gateKey}_OVERRIDE`);
  if (override === 'true' && isQA) {
    return true;
  }
  return gates === null || gates === void 0 ? void 0 : gates.includes(gateKey);
};
export const useIsUngatedForInbound25 = () => {
  return useIsUngated(gate('SSM:Inbound25'));
};